// React Imports
import { ReactElement } from "react";

interface ViewNewsProps {
  onCancel: () => void;
}

const ViewNews: React.FC<ViewNewsProps> = ({
  onCancel,
}: ViewNewsProps): ReactElement => {
  return (
    <div className="flex flex-col w-full px-10 box-border">
      <div className="flex items-center justify-between pb-6 border-b-[1px] border-gray-900 mb-5">
        <h3 className=" text-lg">View news: MENA Markets Daily Report</h3>
      </div>
      <div className="border-b-[1px] border-gray-900">
        <div className="flex flex-col: md:flex-row flex-wrap items-center pb-3 border-b-[1px] border-gray-900 mb-3">
          <p className="w-full md:min-w-[200px]">ID</p>
          <span className=" font-medium">1</span>
        </div>
        <div className="flex flex-col: md:flex-row flex-wrap items-center pb-3 border-b-[1px] border-gray-900 mb-3">
          <p className=" w-full md:min-w-[200px]">Url</p>
          <span className=" font-medium break-words overflow-hidden">https://www.kamcoinvest.com/research/mena-markets-daily-report-1504</span>
        </div>
        <div className="flex flex-col: md:flex-row flex-wrap items-center pb-3 border-b-[1px] border-gray-900 mb-3">
          <p className=" w-full md:min-w-[200px]">Published</p>
          <span className=" font-medium">23 November 2022</span>
        </div>
        <div className="flex flex-col: md:flex-row flex-wrap items-center pb-3 border-b-[1px] border-gray-900 mb-3">
          <p className=" w-full md:min-w-[200px]">Title</p>
          <span className=" font-medium">MENA Markets Daily Report</span>
        </div>
        <div className="flex flex-col: md:flex-row flex-wrap items-center pb-3 border-b-[1px] border-gray-900 mb-3">
          <p className=" w-full md:min-w-[200px]">Pdf Title</p>
          <span className=" font-medium">MENA Markets Daily Report 22-nov-2020.pdf</span>
        </div>
        <div className="flex flex-col: md:flex-row flex-wrap items-center pb-3 border-b-[1px] border-gray-900 mb-3">
          <p className=" w-full md:min-w-[200px]">Pdf Url	</p>
          <span className=" font-medium break-words overflow-hidden">https://www.kamcoinvest.com/sites/default/files/research/pdf/MENA%20Markets%20Daily%20Report%2022-nov-2020.pdf</span>
        </div>
        <div className="flex flex-col: md:flex-row flex-wrap items-center pb-3 border-b-[1px] border-gray-900 mb-3">
          <p className=" w-full md:min-w-[200px]">Language</p>
          <span className=" font-medium">en</span>
        </div>
        <div className="flex flex-col: md:flex-row flex-wrap items-center pb-3 border-b-[1px] border-gray-900 mb-3">
          <p className=" w-full md:min-w-[200px]">Created At</p>
          <span className=" font-medium">2020-11-23 11:21:34</span>
        </div>
        <div className="flex flex-col: md:flex-row flex-wrap items-center pb-3">
          <p className=" w-full md:min-w-[200px]">Updated At</p>
          <span className=" font-medium">2020-11-23 11:21:34</span>
        </div>
      </div>
      <div className="flex items-center justify-end">
        <button
          onClick={onCancel}
          className=" w-full md:w-1/3 cursor-pointer rounded-xl border-[1px] border-blue-500 py-3 px-4 text-base bg-transparent text-blue-500 mt-5 font-medium"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default ViewNews;
